<template lang="pug">
  .hot-deal
    HotdealAsync(v-if="activePromos[productId] && ['active', 'upcoming'].includes(activePromos[productId]?.status)" :productId="productId" :layout="layout" :buy-request="buyRequest")
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { usePromoStore } from '@/js/stores/promoStore'

export default {
  name       : 'hotdeal',
  components : {
    HotdealAsync: defineAsyncComponent(() => import(/* webpackChunkName: "hotdeals" */'./hotdeal-async.vue')),
  },
  props: {
    productId: {
      type     : [Number, String],
      required : false,
    },
    buyRequest: {
      type     : Object,
      required : false,
    },
    layout: {
      type     : String,
      required : false,
    },
  },
  setup() {
    const promoStore = usePromoStore()

    return { promoStore }
  },
  computed: {
    activePromos() {
      return this.promoStore.activePromos
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
